module.exports = __webpack_public_path__ + "static/media/solution-3-sec2.031b8e32.png";